import type { ProductTestDocumentFormValues, ProductTestResultFormValues } from "./schemas"

import type { ProductTest, ProductTestStatus, SignedUrl } from "@/graphql/codegen/graphql"

export enum ProductTestResultPassFail {
  Pass = "PASS",
  Fail = "FAIL",
}

export enum ProductTestResultYesNo {
  Yes = "YES",
  No = "NO",
}

export enum ProductTestDiffType {
  TestResults = "TEST_RESULTS",
  ExpirationDate = "EXPIRATION_DATE",
}

export enum ProductTestActionDialogType {
  Form = "FORM",
  Documents = "DOCUMENTS",
  Override = "OVERRIDE",
  DeleteConfirmation = "DELETE_CONFIRMATION",
}

export type ProductTestWithDocuments = ProductTest & {
  documents: SignedUrl[]
}

export interface ProductTestFormPayload {
  productTest: {
    lotNumber: string
    batchNumber: string | null
    orderIds: number[]
    manufacturingDate: string
    expirationDate: string
    status: ProductTestStatus | null
    results: ProductTestResultFormValues[] | null
    comment: string | null
  }
  documentsToCreate: ProductTestDocumentFormValues[]
  documentsToDelete: string[]
}

export interface ProductTestOverrideResultsPayload {
  productTest: {
    lotNumber?: string
    batchNumber?: string
    results: ProductTestResultFormValues[]
  }
  documentsToCreate: ProductTestDocumentFormValues[]
  documentsToDelete: string[]
}
